import { render, staticRenderFns } from "./Complement.vue?vue&type=template&id=24018b90&"
import script from "./Complement.vue?vue&type=script&lang=js&"
export * from "./Complement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/user/workspace/securamdata/sca-app-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24018b90')) {
      api.createRecord('24018b90', component.options)
    } else {
      api.reload('24018b90', component.options)
    }
    module.hot.accept("./Complement.vue?vue&type=template&id=24018b90&", function () {
      api.rerender('24018b90', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/register-complement/Complement.vue"
export default component.exports